import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationChooseTermPage} from 'features/deposit/onboarding/pages/DepositApplicationChooseTermPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/choose-term',
)({
  component: DepositApplicationChooseTermPage,
  validateSearch: (search) => {
    return {
      productCode: search.productCode as string | undefined,
    };
  },
});
